function squde_flash(str,type) {
    var $ = jQuery.noConflict();
    //Types can be: warning, success, alert, secondary, primary
    if(type == undefined) {
        type = "success";
    }

    var offset = 0;
    if($('.squde-flash').length>0) {
        $('.squde-flash').each(function(){
            offset = offset+$(this).height();
        });
    }

    var id = get_unique_id();
    var html = '' +
        '<div class="squde-flash" id="'+id+'">' +
        '<div class="row collapse">' +
        '<div class="column small-12">' +
        '<div class="callout '+type+'">' +
        '<button type="button" aria-label="Close alert" class="close-button">' +
        '<span aria-hidden="true">×</span>' +
        '</button>' +
        '<span id="str"></span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').prepend(html);
    var f = $('.squde-flash#'+id);
    var maxZ = Math.max.apply(null,
        $.map($('.reveal'), function(e,n) {
            if ($(e).css('position') != 'static')
                return parseInt($(e).css('z-index')) || 1;
        }));
    f.css('z-index',(maxZ+1));
    f.find('span#str').html(str);
    f.find('button.close-button').click(function(e){
        e.preventDefault();
        squde_close_flash(f);
    });
    f.css({'margin-top': f.height()*-1}).animate({'opacity':1,'margin-top':offset},function(){
        var wait_to_remove = setTimeout(function(){
            squde_close_flash(f);
        },3000);
        if(str.length > 200) {
            clearTimeout(wait_to_remove);
        }
    });
}
function squde_close_flash(f) {
    var $ = jQuery.noConflict();
    $('.squde-flash').each(function(){
        $(this).animate({'margin-top':parseInt($(this).css('margin-top')) - f.height()},function(){
            if($(this).attr('id') == f.attr('id')) {
                $(this).remove();
            }
        })
    });
}
function squde_reload_for_flashes(cb) {
    var $ = jQuery.noConflict();
    $.get('/ajax/getFlashMessages', function(data) {
        $.each(data, function(key, value) {
            squde_flash(value.str, value.type);
            if(typeof cb == 'function') {
                cb();
            }
        })
    });
}